import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import NonFictional from './NonFictional';
import Footer from '../common/UI/Footer';
import { useCategories } from '../hooks/categories/useCategories';
import Loading from '../common/HousGlass Loader/Loading';
import ShortStoriesBanner from './language/ShortStoriesBanner';
import OverlayHome from '../Homepage/components/OverlayHome';
import ShortStoriesCategories from './ShortStoriesCategories';
function ShortStoriesNew() {
 
  const { language } = useParams();
  const [dataAudio, setDataAudio] = useState("");
  const { categories, isLoading, isError, error } = useCategories('Audio', language || 'hindi');
  
  // Handle language change
 

  // Update dataAudio based on language parameter
  useEffect(() => {
    if (language === 'hindi') {
      setDataAudio("HindiShortAudios");
    } else if (language === 'english') {
      setDataAudio("EnglishShortAudios");
    } else if (language === 'garhwali') {
      setDataAudio("GarhwaliShortAudios");
    } else if (language === 'kumaoni') {
      setDataAudio("KumaoniShortAudios");
    }
  }, [language]);

  if (isLoading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>
      <Loading />
    </div>;
  }
  
  if (isError) {
    return <div style={{ padding: '20px', textAlign: 'center', color: 'red' }}>
      Error loading categories: {error?.message || "An unknown error occurred"}
    </div>;
  }
  
  if (!categories || categories.length === 0) {
    return (
      <>
        <ShortStoriesBanner language={language} />
        <div style={{ padding: '20px', textAlign: 'center' }}>
          No categories found. Please try again later.
        </div>
        <Footer />
      </>
    );
  }
  
  return (
    <>

      <OverlayHome type={dataAudio} category={"audio"} />
      <ShortStoriesCategories
        categories={categories.map(category => ({
          id: category.id,
          name: category.name
        }))}
      />
      <Footer />
    </>
  );
}

export default ShortStoriesNew
